export const LOGIN_FORM = 'login_form'
export const MFA = 'mfa'
export const MFA_SELECTOR = 'mfa_selector'
